import styles from './WebCamCaptureImage.module.css'
import Webcam from "react-webcam";
import faceFrame from '../../Img/Biometric/faceFrame.png'
import docFrame from '../../Img/Biometric/docFrame.png'
import shot from '../../Img/Biometric/shot.svg'
import shot2 from '../../Img/Biometric/shot.png'
import bioFace from '../../Img/Biometric/bioFace.png'
import {useCallback, useEffect, useRef, useState} from "react";
import ButtonContainer from "../ButtonContainer/ButtonContainer";
interface ICamDevice
{
    deviceId:string
    groupId: string
    kind: string
    label: string
}

interface IWebCamCaptureImageProps
{
    width:number
    frameId:number
    camPad?:number
    aspectRatio?:number
    onShot: (x:string)=>void
}


export default function WebCamCaptureImage({width,camPad,aspectRatio,onShot,frameId}:IWebCamCaptureImageProps)
{

    const [anime, setAnime] = useState(false)

    const [xCamPad, setXCamPad] = useState(camPad ? camPad : 10)
    const [xAspectRatio, setXAspectRatio] = useState(aspectRatio ? aspectRatio : 1.33)
    const [deviceId, setDeviceId] = useState("");
    const [devices, setDevices] = useState<ICamDevice[]>([]);
    const [camWith, setCamWith] = useState(width-xCamPad*2 > 100 ? width-xCamPad*2  : 100)
    const [camDenied, setCamDenied] = useState(false)

    const refCam = useRef<Webcam>(null)

    const [camListToggle, setCamListToggle] = useState(true)
    const [resetTimeoutId, setResetTimeoutId] = useState<NodeJS.Timeout>()



    const [frame,setFrame] = useState<string|undefined>()

    const [selectedCamIdx, setSelectedCamIdx] = useState(0)
    const [videoConstraints, setVideoConstraints] = useState({
        width: {ideal: 2048},
       height: {ideal: 1536},
        //facingMode: "user",
        deviceId: { exact: deviceId  } ,
        video: { width: {exact: 768}, height: {exact: 1024}, resizeMode: "crop-and-scale" },
    })

    const [camReload, setCamReload] = useState(false)



    const handleDevices = useCallback( (mediaDevices: any[]) => {
            setDevices(mediaDevices.filter(({kind}:ICamDevice) => kind === "videoinput"))
    }, [setDevices])


    useEffect(()=>{
        setDefaultCamView()
    },[devices])

    useEffect(()=>{
        //console.log(`frameId ----- ${frameId}`)
        switch (frameId) {
            case 0: setFrame(faceFrame)
                break
            case 1: setFrame(docFrame)
                break
            default: setFrame(undefined)
        }

    },[frameId])

    useEffect(()=>{

        if(width > 500) {
            setCamWith(500 - 2*(camPad ? camPad : 10))
            return
        }
        if(width < 100)
        {
            setCamWith(100)
            return

        }
        setCamWith(width)


    },[width])


    useEffect(()=>{
        console.log(`cam res ${camWith} ${Math.floor(1.33 * camWith)}`)
    }, [camWith])


    useEffect(() => {
        //loadCamList()
        handlePermission()
    },[camWith])


    useEffect(()=>{
        /*if(devices?.length)
        {
            console.log("set default cam device",devices[0].deviceId)
            setVideoConstraints({...videoConstraints,deviceId: {exact: devices[0].deviceId}})
        }*/

    },[devices])

    useEffect(()=>{
        console.log(videoConstraints)
    },[videoConstraints])


    const loadCamList = ()=>{
        navigator.mediaDevices.enumerateDevices().then((e)=>{
            handleDevices(e)
        });
    }





    const handlePermission = ()=>{
        const constraints = {
            video: true,
            audio: false
        };
        navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
                setCamDenied(false)
                loadCamList()

            })
            .catch(error => {
                console.error(error);
                if(error?.message?.match(/denied/)) {
                    setCamDenied(true)
                    return
                }
                setCamDenied(true)
            });
    }


    const resetHideCamList = () =>{

        if(resetTimeoutId)clearTimeout(resetTimeoutId)
        const x = setTimeout(()=>{
            setCamListToggle(true)
        },3000)

        setCamListToggle(false)
        setResetTimeoutId(x)

    }



    const setDefaultCamView = ()=>{
        if( !devices || !devices?.length) return;
        console.log("set def cam")
        const x = devices?.filter((item,_idx)=>item?.label?.match(/(back.*)|(зад.*)|(505)/ui))
        if(x?.length)
        {
            console.log("found cam")
            const item = x[0]
            const idx = devices?.reduce((acc,_item,_idx)=>{
                if(item?.deviceId === _item?.deviceId) acc=_idx
                return acc
            },0)

            setVideoConstraints({...videoConstraints,deviceId: {exact: item?.deviceId}})
            setDeviceId(item?.deviceId)
            setSelectedCamIdx(idx)
            return

        }
        console.log("dev",devices)
        setVideoConstraints({...videoConstraints,deviceId: {exact: devices[0].deviceId}})
    }


    const buildCamList = ()=>{
        if(camDenied) return null


        const x = devices?.map((item, idx)=>{
            return (
                <div key={idx} className={styles.camItem}
                    onClick={()=>{
                        setVideoConstraints({...videoConstraints,deviceId: {exact: item?.deviceId}})
                        setDeviceId(item?.deviceId)
                        setSelectedCamIdx(idx)
                        resetHideCamList()
                        //resetCamera()
                    }}
                >
                    <div className={[styles.camPoint, idx === selectedCamIdx ? styles.camPointActive: ""].join(' ')}></div>
                    {item.label}
                </div>
            )
        })

        if(camListToggle) return (
            <div className={styles.camBundle}
                onClick={()=>resetHideCamList()}
            >
                <img src={shot2}/>
                выбрать камеру
            </div>
        )

        if(! x?.length) return null
        return (
            <div className={styles.camListCont}>
                {x}
            </div>
        )


    }


    const buildCamFrame = () =>{
        if(camDenied) return  (
            <div className={styles.camError}>
                Доступ к камере запрещен, дайте разрешение для использования камеры
            </div>
        )
        //console.log(`frame---- ${frame}`)
        return(
            <div className={styles.frameCont}>
                { frame !==undefined && <img src={frame} style={{width: camWith, height:Math.floor(xAspectRatio * camWith)}}/>}
                {frame !==undefined && frameId === 0 &&
                    <div className={styles.faceExCont}>
                        <img src={bioFace}/>
                        <div>пример</div>
                    </div>
                }
            </div>

        )
    }

    const buildShot = ()=>{
        return(
            <div className={styles.camShot}>
                {anime && <div className={styles.shSave}>сохранение...</div>}
                <img src={shot2} className={anime ? styles.clickAnime : ""}
                    onClick={()=>{
                        setAnime(true)
                        setTimeout(()=>handleShot(),700)
                    }}
                />
            </div>
        )
    }

    const handleShot = ()=>{
        if(refCam.current === null) return
        const x = refCam.current.getScreenshot()
//        const x = refCam.current.getScreenshot({width:768, height:1024})
//        const y = refCam.current.
        //console.log(x)
        if(x?.length && onShot)onShot(x)


    }


    return(
        <div className={styles.mainCont}>
            <div className={styles.camFrame}>
                {buildCamList()}
                {buildCamFrame()}
                <Webcam
                    audio={false}
                    height={Math.floor(xAspectRatio * camWith)}
                    screenshotFormat="image/png"

                    width={camWith}
                    videoConstraints={videoConstraints}
                    //videoConstraints={{}}
                    ref={refCam}
                    forceScreenshotSourceSize={true}
                    imageSmoothing={false}



                />
                {buildShot()}
            </div>



        </div>
    )
}